// This import loads the firebase namespace along with all its type information.
import SystemRole from './system-role-model'

export async function load_systemRoles(): Promise<SystemRole[]> {
  throw 'Not implemented'
}

export async function delete_systemRole(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_systemRole(): Promise<SystemRole> {
  throw 'Not implemented'
}
